<template>
  <div class="recipe">
    <myNav />
    <div class="bannerd">
      <div class="y900">
        <div class="rzpart3">
          <div class="content">
            <p>{{ list.company_name }}</p>
            <p class="p2">联系方式：{{list.mobile}}</p>
            <div class="tipa">{{list.addtime}}</div>
            <div class="con" v-html="list.company_content"></div>
            <div class="lx">联系方式： <span>{{list.mobile}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      list: [],
      page: 0,
    };
  },
  activated() {
    this.$axios({
      url: "Index/agent_detail",
      method: "GET",
      params: {
        agent_id: this.$route.query.admin_id,
      },
    }).then((res) => {
      console.log("我可以获取到代账详情数据吗", res);
      this.list = res.data.data.info;
    });
  },
  methods: {
  },
};
</script>
<style scoped>
.rzpart1 {
}
.rzpart1 h1 {
  font-size: 40px;
  color: #fff;
  padding-top: 75px;
  font-weight: 800;
}
.rzpart1 h2 {
  font-size: 20px;
  color: #fff;
  padding-top: 20px;
}
.rzpart1 .to {
  display: inline-block;
  padding-top: 50px;
}
.to_img {
  padding-right: 25px;
}
.rzpart2 p {
  padding-top: 50px;
  padding-bottom: 50px;
  font-size: 40px;
  color: #fff;
  font-weight: 800;
}
.tab {
  width: 100%;
  height: 295px;
  border-radius: 5px;
  background: #fff;
}
.rzpart3 {
  padding-top: 460px;
  min-height: 600px;
  width: 900px;
}
.rzpart3 p {
  color: #000000;
  font-size: 31px;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: 800;
  width: 80%;
  margin: 0 auto;
}
.rzpart3 .p2 {
  color: #000000;
  font-size: 31px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: 800;
  width: 80%;
  margin: 0 auto;
  display: block;
}
.rzpart3 .content {
  background: #fff;
  min-height: 600px;
  position: relative;
}
.content .tipa {
  width: 80%;
  font-size: 15px;
  margin: 0 auto;
  padding-bottom: 10px;
}
.content .con {
  width: 80%;
  font-size: 18px;
  margin: 0 auto;
  padding-bottom: 100px;
}
.content .lx {
  position: absolute;
  bottom: 10px;
  right: 0;
  font-size: 30px;
  width: 280px;
}
</style>

